import { ChangeEventHandler } from 'react'
import { ArrowRightOutlined, CheckOutlined, CiCircleFilled, MinusCircleFilled } from '@ant-design/icons'
import { Select, DatePicker, Input } from 'antd'
import moment, { Moment } from 'moment'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  BookingDto,
  BookingStatus,
  BOOKING_TYPE,
  ContractBookingListFilterQuery,
  ListBookingResponseDto,
  BookingListStatusFilter,
  TaskStatus
} from '../../../../definition/booking.dto'
import { appEventEmitter, processLoading } from '../../../../initialization'
import { asyncDeleteBooking, asyncGetScheduleBookings } from '../../../../services/booking.service'
import { getQueryParams } from '../../../../utils'
import PaddingComponent from '../../../components/paging.component'
import contractIcon from './../../../../styles/images/contract-icon.png'
import searchIcon from './../../../../styles/images/search-icon.png'
import { debounce } from 'lodash'
import { APP_EVENTS, SWITCH_FUNCTION } from '../../../../constants'
import { ServiceDto } from '../../../../definition'
import { asyncGetServices } from '../../../../services'
import DeleteIcon from '../../../../styles/images/delete-icon.png'
import { ConfirmModalData } from '../../../components/confirm-modal.component'
import getTaskStatus from '../../../components/task-status.component'
import { FinanceTaskStatus } from '../../../../definition/finance-task.dto'

const { RangePicker } = DatePicker

enum FilterStatus {
  Ver1 = 'Ver1',
  Ver2 = 'Ver2',
  Ver3 = 'Ver3'
}

const FILTER_STATUS_VER = FilterStatus.Ver3

let Statuses: { label: string; value?: BookingStatus | 'All Statuses' }[] = [
  { label: 'All Statuses', value: 'All Statuses' },
  { label: 'Awaiting Quotation', value: BookingStatus.NEW },
  { label: 'Quote Approved', value: BookingStatus.QUOTE_ACCEPTED },
  { label: 'Quote Sent', value: BookingStatus.QUOTE_ATTACHED },
  { label: 'Request for new quote', value: BookingStatus.NEW_QUOTE_REQUESTED },
  { label: 'Request admin to plan', value: BookingStatus.ADMIN_PLANNING },
  { label: 'Self Planned', value: BookingStatus.SELF_PLANNED },
  { label: 'Completed', value: BookingStatus.DONE }
]

if (SWITCH_FUNCTION.remove_quote_from_flow) {
  Statuses = [
    { label: 'All Statuses', value: 'All Statuses' },
    { label: 'Invoice Attached', value: BookingStatus.QUOTE_ACCEPTED },
    { label: 'Request admin to plan', value: BookingStatus.ADMIN_PLANNING },
    { label: 'Self Planned', value: BookingStatus.SELF_PLANNED },
    { label: 'Completed', value: BookingStatus.DONE }
  ]
}

export const MappingStatuses = [
  { label: 'Pending Payment', value: BookingListStatusFilter.PENDING_PAYMENT },
  { label: 'Require admin to plan', value: BookingListStatusFilter.ADMIN_PLANNING },
  // { label: 'Reassign Required', value: BookingListStatusFilter.REASSIGN },
  { label: 'Reschedule required', value: BookingListStatusFilter.RESCHEDULE },
  { label: 'Booking confirmed', value: BookingListStatusFilter.CONFIRMED },
  { label: 'Completed ', value: BookingListStatusFilter.COMPLETED },
  { label: 'Canceled ', value: BookingListStatusFilter.CANCELED }
]

export const MappingTaskStatus = [
  { label: 'New Booking', value: TaskStatus.CREATED },
  // { label: 'Reassign Required', value: TaskStatus.REASSIGN },
  { label: 'Assigned', value: TaskStatus.ASSIGNED },
  { label: 'On The Way', value: TaskStatus.ON_THE_WAY },
  { label: 'Task Started', value: TaskStatus.STARTED },
  { label: 'Finalising', value: TaskStatus.COMPLETED },
  { label: 'Completed', value: TaskStatus.DONE },
  { label: 'Reschedule Required', value: TaskStatus.RESCHEDULE }
]

const limit = 10
type ContractBookingListComponentStateType = {
  bookings: BookingDto[]
  search?: string
  status: BookingStatus | 'All Statuses'
  statusMapping: BookingListStatusFilter | undefined
  bookingStatus?: BookingStatus | undefined
  taskStatus: TaskStatus | undefined
  bookingType?: 'One Time' | 'Recurring'
  selectedPage: number
  totalPage: number
  serviceId?: string
  startTime: Date
  endTime: Date
}

export const getMappingStatus = (item: BookingDto) => {
  if (item.statusMapping === BookingListStatusFilter.PENDING_PAYMENT) {
    return 'Pending Payment'
  } else if (item.statusMapping === BookingListStatusFilter.ADMIN_PLANNING) {
    return 'Require admin to plan'
  } else if (item.statusMapping === BookingListStatusFilter.REASSIGN) {
    return 'Reassign Required'
  } else if (item.statusMapping === BookingListStatusFilter.RESCHEDULE) {
    return 'Reschedule required'
  } else if (item.statusMapping === BookingListStatusFilter.CONFIRMED) {
    return 'Booking confirmed'
  } else if (item.statusMapping === BookingListStatusFilter.COMPLETED) {
    return 'Completed'
  } else if (item.statusMapping === BookingListStatusFilter.CANCELED) {
    return 'Canceled'
  }
}

export const getMasterBookingStatus = (item: BookingDto) => {
  if (item.status === BookingStatus.ACTIVE) {
    return (
      <div className='booking-active-badge'>
        <CheckOutlined /> Active
      </div>
    )
  } else if (item.status === BookingStatus.PAUSE) {
    return (
      <div className='booking-ended-badge'>
        <CiCircleFilled /> Paused
      </div>
    )
  } else if (item.status === BookingStatus.ENDED) {
    return (
      <div className='booking-ended-badge'>
        <MinusCircleFilled /> Ended
      </div>
    )
  } else {
    return ''
  }
}

const initStartTaskFilterDate = moment().startOf('month').toDate()
const initEndTaskFilterDate = moment().endOf('month').toDate()

export const ContractBookingListComponent2 = () => {
  const navigate = useNavigate()
  const queries = getQueryParams<any>()
  const [services, setServices] = useState<ServiceDto[]>([])
  const [state, setState] = useState<ContractBookingListComponentStateType>({
    bookings: [],
    status: 'All Statuses',
    statusMapping: undefined,
    bookingStatus: undefined,
    taskStatus: undefined,
    selectedPage: queries.selectedPage || 0,
    search: queries.searching || '',
    totalPage: 1,
    serviceId: '',
    startTime: initStartTaskFilterDate,
    endTime: initEndTaskFilterDate
  })

  const onLoad = ({
    search,
    status,
    statusMapping,
    bookingStatus,
    taskStatus,
    bookingType,
    selectedPage,
    serviceId,
    startTime,
    endTime
  }: {
    search?: string
    status: BookingStatus | 'All Statuses'
    statusMapping: BookingListStatusFilter | undefined
    bookingStatus: BookingStatus | undefined
    taskStatus: TaskStatus | undefined
    bookingType?: 'One Time' | 'Recurring'
    selectedPage: number
    serviceId?: string
    startTime: Date
    endTime: Date
  }) => {
    const params: ContractBookingListFilterQuery = {
      limit,
      offset: selectedPage * limit,
      search: search || undefined,
      status: status === 'All Statuses' ? undefined : status,
      statusMapping: statusMapping,
      bookingStatus: bookingStatus,
      taskStatus: taskStatus,
      type: bookingType || undefined,
      serviceId: serviceId || undefined,
      startTime,
      endTime
    }

    processLoading(
      asyncGetScheduleBookings(params)
        .then((res: ListBookingResponseDto) => {
          const totalPage = Math.floor(((res?.count || 0) - 1) / limit) + 1
          setState({
            search,
            status,
            statusMapping,
            bookingStatus,
            taskStatus,
            bookingType,
            selectedPage,
            totalPage,
            bookings: res.items,
            startTime,
            endTime
          })
        })
        .catch((error: any) => {
          toast.error(`Can not get contract bookings!${error.response?.data?.error?.message || error.message}`)
        })
    )
  }

  useEffect(() => {
    doFetchServiceList()
    onLoad(state)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const doFetchServiceList = async (search?: string) => {
    const res = await asyncGetServices({ search, all: true })
    if (res && res.items) setServices(res.items)
  }

  const getFiter = () => {
    return {
      search: state.search,
      status: state.status,
      statusMapping: state.statusMapping,
      bookingStatus: state.bookingStatus,
      bookingType: state.bookingType,
      selectedPage: state.selectedPage,
      serviceId: state.serviceId,
      startTime: state.startTime,
      endTime: state.endTime,
      taskStatus: state.taskStatus
    }
  }

  const onChangeStatus = (status: BookingStatus | 'All Statuses') => {
    onLoad({ ...getFiter(), status, selectedPage: 0 })
  }

  const onChangeMappingStatus = (statusMapping: BookingListStatusFilter | undefined) => {
    onLoad({ ...getFiter(), statusMapping, selectedPage: 0 })
  }

  const onChangeBookingStatus = (bookingStatus: BookingStatus | undefined) => {
    onLoad({ ...getFiter(), bookingStatus, selectedPage: 0 })
  }

  const onChangeTaskStatus = (taskStatus: TaskStatus | undefined) => {
    onLoad({ ...getFiter(), taskStatus, selectedPage: 0 })
  }

  const onSearch = (search: string) => {
    onLoad({ ...getFiter(), search, selectedPage: 0 })
  }

  const onPageChange = (selectedPage: number) => {
    onLoad({ ...getFiter(), selectedPage })
  }

  const onChangeBookingType = (bookingType?: 'One Time' | 'Recurring') => {
    onLoad({ ...getFiter(), search: '', bookingType, status: 'All Statuses', selectedPage: 0 })
  }

  const onServiceChange = (id: string) => {
    onLoad({ ...getFiter(), serviceId: id, selectedPage: 0 })
  }

  const onRangeChange = (dates: null | (Moment | null)[], dateStrings: string[]) => {
    if (dates && dates[0] && dates[1]) {
      const startDay = new Date(new Date(moment(dates[0]).startOf('day').toISOString()))
      const endDay = new Date(new Date(moment(dates[1]).endOf('day').toISOString()))

      onLoad({ ...getFiter(), startTime: startDay, endTime: endDay, selectedPage: 0 })
    }
  }

  const onDetailBooking = (item: BookingDto) => {
    if (item.type === BOOKING_TYPE.ONE_TIME) {
      navigate(`/schedule/one-time-booking?bookingId=${item.id}`)
    } else if (item.type === BOOKING_TYPE.RECURRING) {
      navigate(`/schedule/contract-booking?bookingId=${item.id}`)
    } else if (item.type === BOOKING_TYPE.RECURRING2) {
      navigate(`/schedule/recurring-booking?bookingId=${item.id}`)
    }
  }

  const handleDeleteBooking = (booking: BookingDto) => {
    const processDelete = async () => {
      await asyncDeleteBooking(booking.id)
    }

    appEventEmitter.emit<ConfirmModalData>(APP_EVENTS.app_confirm_modal, {
      title: (
        <>
          Are you sure you want to delete Booking No. {booking.code}?
          <br />
          Once deleted it cannot be undone.
        </>
      ),
      onOK: () =>
        processLoading(
          processDelete()
            .then(() => {
              toast.success('Delete')
              onLoad({ ...getFiter() })
            })
            .catch((error) => {
              let errorMessage =
                error?.response?.status >= 500 ? (
                  <>
                    Can not process the deletion!.
                    <br />
                    Maybe service have the related data, so we can not delete it.
                    <br />
                    Please contact with admin developer for get more detail!
                  </>
                ) : (
                  error.response?.data?.error?.message || error.message
                )
              toast.error(errorMessage)
            })
        )
    })
  }

  const getStatus = (item: BookingDto) => {
    if (item.status === BookingStatus.NEW && !item.quote) {
      return 'Awaiting Quotation'
    } else if (item.status === BookingStatus.QUOTE_ATTACHED) {
      return 'Quote sent'
    } else if (item.status === BookingStatus.NEW_QUOTE_REQUESTED) {
      return 'Request for new quote'
    } else if (item.status === BookingStatus.QUOTE_REJECTED) {
      return 'Quote Rejected'
    } else if (item.status === BookingStatus.QUOTE_ACCEPTED) {
      if (SWITCH_FUNCTION.remove_quote_from_flow) return 'Invoice Attached'
      return 'Quote Approved'
    } else if (item.status === BookingStatus.SELF_PLANNED) {
      return 'Self Planned '
    } else if (item.status === BookingStatus.ADMIN_PLANNING) {
      return 'Request admin to plan '
    } else if (item.status === BookingStatus.ADMIN_PLANNED) {
      return 'Admin planned'
    } else if (item.status === BookingStatus.INVOICE_PAID) {
      return 'Invoice paid'
    } else if (item.status === BookingStatus.DONE) {
      return 'Completed'
    } else if (item.status === BookingStatus.CANCELED) {
      return 'Cancel'
    }
  }

  const onSearching: ChangeEventHandler<HTMLInputElement> = (e) => {
    onSearch(e.target.value)
  }

  const debounceOnSeaching = debounce(onSearching, 1000)

  return (
    <div className='booking-contract-area'>
      <div className='booking-contract-title'>
        <img alt='contract' src={contractIcon} />
        <span>Bookings List</span>
      </div>
      <div className='booking-contract-wrapper'>
        <div className='booking-contract-search'>
          {/* <div className='booking-contract-search-left'>
            <span className={!state.bookingType ? 'select' : ''} onClick={() => onChangeBookingType()}>
              All Bookings
            </span>
            <span
              className={state.bookingType === 'Recurring' ? 'select' : ''}
              onClick={() => onChangeBookingType('Recurring')}
            >
              Contract Bookings
            </span>
            <span
              className={state.bookingType === 'One Time' ? 'select' : ''}
              onClick={() => onChangeBookingType('One Time')}
            >
              One-time Bookings
            </span>
          </div> */}
          <div className='booking-contract-search-action'>
            <Select
              className='booking-contract-select-status'
              options={[
                { label: 'One-time Bookings', value: 'One Time' },
                { label: 'Contract Bookings', value: 'Recurring' },
                { label: 'Recurring Bookings', value: 'Recurring2' }
              ]}
              placeholder='All Bookings'
              onChange={(value) => onChangeBookingType(value)}
              allowClear
              onClear={() => onChangeBookingType()}
            />
            <Select
              value={state.serviceId}
              className='booking-contract-select-status'
              showSearch
              allowClear
              style={{ minWidth: 200, fontSize: 14 }}
              placeholder='All Services'
              optionFilterProp='children'
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              options={(services || []).map((service) => ({
                label: service.name,
                value: service.id
              }))}
              onChange={(value: string) => onServiceChange(value)}
              onClear={() => onServiceChange('')}
            />
            {FILTER_STATUS_VER === FilterStatus.Ver1 && (
              <Select
                value={state.status}
                className='booking-contract-select-status'
                options={Statuses.map((status) => {
                  return { value: status.value, label: status.label }
                })}
                onSelect={(value: BookingStatus | 'All Statuses') => onChangeStatus(value)}
              />
            )}
            {FILTER_STATUS_VER === FilterStatus.Ver2 && (
              <Select
                placeholder='All Statuses'
                allowClear
                value={state.statusMapping}
                className='booking-contract-select-status'
                options={MappingStatuses.map((status) => {
                  return { value: status.value, label: status.label }
                })}
                onSelect={(value: BookingListStatusFilter) => onChangeMappingStatus(value)}
                onClear={() => onChangeMappingStatus(undefined)}
              />
            )}
            {FILTER_STATUS_VER === FilterStatus.Ver3 && (
              <>
                <Select
                  placeholder='All Master Booking Status'
                  allowClear
                  value={state.bookingStatus}
                  className='booking-contract-select-status'
                  options={[
                    { label: 'Active', value: BookingStatus.ACTIVE },
                    { label: 'Pause', value: BookingStatus.PAUSE },
                    { label: 'Ended', value: BookingStatus.ENDED }
                  ]}
                  onSelect={(value: BookingStatus) => onChangeBookingStatus(value)}
                  onClear={() => onChangeBookingStatus(undefined)}
                />
                <Select
                  placeholder='All Task Statuses'
                  allowClear
                  value={state.statusMapping}
                  className='booking-contract-select-status'
                  options={MappingTaskStatus.map((status) => {
                    return { value: status.value, label: status.label }
                  })}
                  onSelect={(value: TaskStatus) => onChangeTaskStatus(value)}
                  onClear={() => onChangeTaskStatus(undefined)}
                />
              </>
            )}
            <RangePicker
              style={{ width: 240 }}
              value={[moment(state.startTime) || null, moment(state.endTime) || null]}
              picker={'date'}
              format={'DD/MM/YYYY'}
              onChange={onRangeChange}
            />
            <div className='booking-contract-search-input'>
              <Input
                className='search-input'
                placeholder="Search code, customer's name"
                onChange={(event) => debounceOnSeaching(event)}
              />
              <img alt='search' className='search-icon' src={searchIcon} />
            </div>
          </div>
        </div>
        <div className='booking-contract-table'>
          <div className='booking-contract-table-header'>
            <div className='f2'>Booking Number</div>
            <div className='f1'>Created On</div>
            <div className='f2'>Customer Name</div>
            <div className='f2'>Customer Contact No.</div>
            <div className='f3'>Service Name</div>
            <div className='f2'>Master Booking Status</div>
            <div className='f2'>Task Status</div>
            <div style={{ width: '60px' }}></div>
          </div>

          {(state?.bookings || []).map((item, index) => (
            <div
              onClick={() => onDetailBooking(item)}
              key={item.id}
              className={`booking-contract-table-row ${index % 2 === 0 ? 'row-separate' : ''}`}
            >
              <div className='f2'>{item.code}</div>
              <div className='f1'>{moment(item.createdAt).format('DD/MM/YYYY')}</div>
              <div className='f2'>{item.account?.profile?.name}</div>
              <div className='f2'>
                {SWITCH_FUNCTION.country_code ? item.account?.profile?.countryCode : null}{' '}
                {item.account?.profile?.contact}
              </div>
              <div className='f3 service-duration'>
                {item.bookedServices?.map((service) => {
                  return <div>{service.service?.name}</div>
                })}
              </div>
              <div className='f2'>{getMasterBookingStatus(item)}</div>
              {FILTER_STATUS_VER === FilterStatus.Ver1 ? <div className='f2'>{getStatus(item)}</div> : null}
              {FILTER_STATUS_VER === FilterStatus.Ver2 ? <div className='f2'>{getMappingStatus(item)}</div> : null}
              {FILTER_STATUS_VER === FilterStatus.Ver3 ? (
                <div className='f2'>
                  {item.tasks?.map((task) => {
                    return (
                      <div
                        style={{ marginBottom: 4, marginTop: 4 }}
                        className={`task-status ${getTaskStatus(task.status).cssStatus}`}
                      >
                        {getTaskStatus(task.status).statusLabel}
                      </div>
                    )
                  })}
                </div>
              ) : null}
              <div className='booking-action'>
                <div
                  onClick={(e) => {
                    e.stopPropagation()
                    handleDeleteBooking(item)
                  }}
                >
                  <img src={DeleteIcon} alt='delete' />
                </div>

                <div className='action' onClick={() => onDetailBooking(item)}>
                  <ArrowRightOutlined />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <PaddingComponent
            selectedPage={state.selectedPage}
            totalPage={state.totalPage}
            numberDisplayedIndex={limit}
            onSelectIndex={onPageChange}
            className='customer-page-paging'
          />
        </div>
      </div>
    </div>
  )
}
